<template>
    <v-layout justify-center row>
        <v-dialog persistent v-model="state.dialogVisible" width="500">
            <v-card color="primary" dark>
                <v-card-text>
                    {{ state.message }}
                    <v-progress-linear color="white" indeterminate></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import ProgressDialogStore from "../../ts/stores/ProgressDialogStore";

    export default {
        name: "ProgressDialog",

        data() {
            return {
                state: ProgressDialogStore.state
            }
        },
    }
</script>
